import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import { CloseIcon } from './Styles/Icons';
import { InputGroup, TextField, ButtonGroup, Button, FlexRow, Select, Dialog, DialogActions, DialogTitle, DialogContent, CircularButton } from './Styles/UpdateShippingDialogBox';

import { generateShippingUrl } from '../../commons/utils';

import { SHIPPING_COMPANIES } from '../../commons/utils';
import { MenuItem } from '../Styles';

const UpdateShippingDialogBox = ({ open, onTrue, onFalse, shippingCompanyOptions }) => {
	const [error, setError] = useState(null);
	const [shippingCompany, setShippingCompany] = useState('');
	const [shippingId, setShippingId] = useState('');

	const onTrueHandler = () => {
		let errorState = {};
		setError(errorState);

		if (!shippingCompany) {
			errorState['shippingCompany'] = 'Shipping company cannot be empty.';
		}
		if (!shippingId) {
			errorState['shippingId'] = 'Shipping ID cannot be empty.';
		}

		if (Object.keys(errorState).length) {
			setError(errorState);
		} else {
			onTrue(generateShippingUrl(shippingCompany, shippingId));
		}
	};

	const onFalseHandler = () => {
		onFalse();
	};

	useEffect(() => {
		setShippingCompany('');
		setShippingId('');
		setError({});
	}, [open]);

	return (
		<Dialog
			open={open}
			onClose={() => onFalseHandler()}
			fullWidth
		>
			<DialogTitle>
				Update Shipping Details
				<ButtonGroup alignRight>
					<CircularButton
						error
						outline
						onClick={() => onFalseHandler()}
					>
						<CloseIcon />
					</CircularButton>
				</ButtonGroup>
			</DialogTitle>

			<DialogContent>
				<FlexRow>
					<InputGroup
						label='Shipping Company'
						markRequired={true}
						error={error && error.shippingCompany}
					>
						<Select
							name={'shipping_company'}
							placeholder='Select company'
							disabled={false}
							enableSearch={true}
							value={shippingCompany}
							onChange={(e) => {
								setShippingCompany(e.target.value);
							}}
							error={error && error.shippingCompany}
						>
							{shippingCompanyOptions.map((item) => (
								<MenuItem
									key={item.value}
									value={item.value}
									disabled={item.disabled}
								>
									{item.name}
								</MenuItem>
							))}
						</Select>
					</InputGroup>
				</FlexRow>

				<FlexRow>
					<InputGroup
						label='Shipping ID'
						markRequired={true}
						error={error && error.shippingId}
					>
						<TextField
							name='shipping_id'
							placeholder='Enter shipping id'
							value={shippingId}
							disabled={false}
							onChange={(e) => setShippingId(e.target.value)}
							error={error && error.shippingId}
						/>
					</InputGroup>
				</FlexRow>
			</DialogContent>

			<DialogActions style={{ margin: '0 0.5rem' }}>
				<ButtonGroup alignRight>
					<Button
						primary
						outline
						onClick={(e) => onFalseHandler()}
					>
						Cancel
					</Button>
					<Button
						primary
						onClick={(e) => onTrueHandler()}
					>
						Confirm
					</Button>
				</ButtonGroup>
			</DialogActions>
		</Dialog>
	);
};

const mapStatesToProps = (state) => {
	const shippingCompanyOptions = Object.keys(SHIPPING_COMPANIES).map((company) => ({ name: company, value: company, disabled: false }));
	
	return {
		supplier: state.supplier.supplier,
		shippingCompanyOptions,
	};
};

const mapFunctionsToProps = {};

export default connect(mapStatesToProps, mapFunctionsToProps)(UpdateShippingDialogBox);
